// Path: ./src/app/pages/CameraPage/uploadSuccess.tsx
import React from "react";
import { messages } from "../../../locales/messages";
import { useTranslation } from "react-i18next";

export default function CameraUploadSuccess() {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // This ensures that the div takes the full viewport height
        fontSize: "24px", // Optional, for styling the text size
        fontWeight: "bold", // Optional, for styling the text weight
      }}
      data-testid="camerauploadsuccess-test-id"
    >
      {t(messages.Upload_successful_Please_close_the_browser())}
    </div>
  );
}
